"use strict";

function _defineProperty2(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DataStorage = void 0;
var _javascriptSdkCore = require("@kameleoon/javascript-sdk-core"),
  _visitorCodeManager = require("./visitorCodeManager");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var DataStorage = /*#__PURE__*/function () {
  function DataStorage() {
    _classCallCheck(this, DataStorage);
    _defineProperty(this, "visitorCodeManager", void 0);
  }
  return _createClass(DataStorage, [{
    key: "read",
    value: function read(a) {
      var b = localStorage.getItem(a);
      if (!b) {
        if (a === _javascriptSdkCore.KameleoonStorageKey.ConsentData) {
          var _a = this.getEngineConsentData();
          if (_a) return _a;
        }
        return null;
      }
      return JSON.parse(b);
    }
  }, {
    key: "write",
    value: function write(a, b) {
      localStorage.setItem(a, JSON.stringify(b));
    }
  }, {
    key: "getEngineConsentData",
    value: function getEngineConsentData() {
      this.visitorCodeManager || (this.visitorCodeManager = new _visitorCodeManager.KameleoonVisitorCodeManager());
      var a = this.visitorCodeManager.getData(_javascriptSdkCore.KameleoonStorageKey.VisitorCode);
      if (!a) return null;
      try {
        var b;
        var c = localStorage.getItem("kameleoonLegalConsent");
        if (!c) return null;
        var d = JSON.parse(c);
        return "boolean" == typeof (null === d || void 0 === d || null === (b = d.value) || void 0 === b ? void 0 : b.AB_TESTING) ? _defineProperty2({}, a, d.value.AB_TESTING) : null;
      } catch (_) {
        return null;
      }
    }
  }]);
}();
exports.DataStorage = DataStorage;